<section id="team" class="team-section">
  <div class="container">
    <div class="team-header text-center" appAnimateOnScroll="fade-in-up">
      <h2 class="section-title">{{ 'team.TITLE' | translate }}</h2>
      <p class="section-subtitle">{{ 'team.SUBTITLE' | translate }}</p>
    </div>
    <div class="team-grid">
      @for (member of teamMembers; track member; let i = $index) {
        <div appAnimateOnScroll="fade-in-up" [style.transition-delay.ms]="i * 150">
          <div class="team-member-card">
            <div class="card-image-wrapper">
              <img [src]="member.image" alt="{{'team.members.' + member.key + '.NAME' | translate}}" class="member-image">
              <div class="member-info">
                <h3 class="member-name">{{ 'team.members.' + member.key + '.NAME' | translate }}</h3>
                <p class="member-role">{{ 'team.members.' + member.key + '.ROLE' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>